import { Component, Show, createMemo } from 'solid-js';
import { ContentType } from '@dtvgo/backend-service';

import CategoryLabel from '~/components/CategoryLabel';
import HorizontalList from '~/components/HorizontalList';
import Rating from '~/components/Rating';

import { formatSecondsInText } from '~/utils/functions';
import { MESSAGES } from '~/utils/messages';
import { text } from '~/utils/constants';
import { getAssetDuration } from '~/utils/metadata';

interface AssetMetadataProps {
  isLive: boolean;
  asset: {
    title?: string | null;
    type?: ContentType;
    rating?: string | null;
    duration?: number | null;
    genres?: string[] | null;
    episode?: {
      showName?: string | null;
      seasonNumber?: number | null;
      number?: number | null;
    } | null;
    vod?: {
      duration?: number | null;
      releaseYear?: number | null;
    } | null;
    live?: {
      startTime: Date;
      endTime: Date;
    } | null;
  };
}

const AssetMetadata: Component<AssetMetadataProps> = (props) => {
  const assetDuration = createMemo(() => {
    const durationInSecs = getAssetDuration(props.asset);

    if (typeof durationInSecs !== 'number') {
      return undefined;
    }

    return formatSecondsInText(durationInSecs);
  });

  const title = () => {
    if (props.asset.type === ContentType.EPISODE) {
      return props.asset.episode?.showName || props.asset.title;
    }

    return props.asset.title;
  };

  return (
    <div class="flex flex-col gap-4">
      <Show when={!!props.asset.type}>
        <CategoryLabel type={props.asset.type!} isLive={props.isLive} />
      </Show>
      <h1 class={text.heading3XL}>
        {title() || MESSAGES.METADATA.NO_INFO_AVAILABLE}
      </h1>
      <div
        class={`flex items-center gap-3 ${text.bodyM} text-neutral-text-secondary`}
      >
        <Show when={!!props.asset.rating}>
          <Rating rating={props.asset.rating!} />
        </Show>
        <HorizontalList
          items={[
            props.asset.vod?.releaseYear,
            assetDuration(),
            ...(props.asset.type === ContentType.EPISODE ?
              [
                [
                  `${MESSAGES.METADATA.SEASON_FIRST_CHARACTER}${props.asset.episode?.seasonNumber}`,
                  `${MESSAGES.METADATA.EPISODE_FIRST_CHARACTER}${props.asset.episode?.number}`,
                ].join(' '),
                props.asset.title,
              ]
            : [props.asset.genres?.join(', ')]),
          ].filter(Boolean)}
        />
      </div>
    </div>
  );
};

export default AssetMetadata;
